import Icon from '@/components/ui/AppIcon';

interface QualityBadge {
  id: number;
  icon: string;
  title: string;
  description: string;
  color: string;
}

export default function QualityBadges() {
  const badges: QualityBadge[] = [
    {
      id: 1,
      icon: "ShieldCheckIcon",
      title: "FSSAI Certified",
      description: "Licensed food safety standards compliance",
      color: "success"
    },
    {
      id: 2,
      icon: "SparklesIcon",
      title: "Fresh Ingredients",
      description: "Daily sourced premium quality ingredients",
      color: "secondary"
    },
    {
      id: 3,
      icon: "ClockIcon",
      title: "Quick Service",
      description: "Hot & fresh delivery in 30 minutes",
      color: "primary"
    },
    {
      id: 4,
      icon: "HeartIcon",
      title: "Authentic Recipes",
      description: "Traditional methods, genuine flavors",
      color: "error"
    }
  ];

  return (
    <section data-component-id="src/app/homepage/components/QualityBadges.tsx:44:4" data-component-path="src/app/homepage/components/QualityBadges.tsx" data-component-line="44" data-component-file="QualityBadges.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-16%20bg-background%22%7D" className="py-16 bg-background">
      <div data-component-id="src/app/homepage/components/QualityBadges.tsx:45:6" data-component-path="src/app/homepage/components/QualityBadges.tsx" data-component-line="45" data-component-file="QualityBadges.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-4%22%7D" className="container mx-auto px-4">
        <div data-component-id="src/app/homepage/components/QualityBadges.tsx:46:8" data-component-path="src/app/homepage/components/QualityBadges.tsx" data-component-line="46" data-component-file="QualityBadges.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20md%3Agrid-cols-2%20lg%3Agrid-cols-4%20gap-6%22%7D" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {badges.map((badge) => (
            <div data-component-id="src/app/homepage/components/QualityBadges.tsx:48:12" data-component-path="src/app/homepage/components/QualityBadges.tsx" data-component-line="48" data-component-file="QualityBadges.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20rounded-lg%20p-6%20text-center%20border%20border-border%20hover%3Ashadow-brand-hover%20transition-smooth%20group%22%7D"
              key={badge.id}
              className="bg-card rounded-lg p-6 text-center border border-border hover:shadow-brand-hover transition-smooth group"
            >
              <div data-component-id="src/app/homepage/components/QualityBadges.tsx:52:14" data-component-path="src/app/homepage/components/QualityBadges.tsx" data-component-line="52" data-component-file="QualityBadges.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-${badge.color}/10 rounded-full group-hover:scale-110 transition-transform`}>
                <Icon data-component-id="src/app/homepage/components/QualityBadges.tsx:53:16" data-component-path="src/app/homepage/components/QualityBadges.tsx" data-component-line="53" data-component-file="QualityBadges.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D"
                  name={badge.icon as any}
                  size={32}
                  className={`text-${badge.color}`}
                />
              </div>
              <h3 data-component-id="src/app/homepage/components/QualityBadges.tsx:59:14" data-component-path="src/app/homepage/components/QualityBadges.tsx" data-component-line="59" data-component-file="QualityBadges.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22font-headline%20font-headline-bold%20text-lg%20text-primary%20mb-2%22%7D" className="font-headline font-headline-bold text-lg text-primary mb-2">
                {badge.title}
              </h3>
              <p data-component-id="src/app/homepage/components/QualityBadges.tsx:62:14" data-component-path="src/app/homepage/components/QualityBadges.tsx" data-component-line="62" data-component-file="QualityBadges.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-body%20text-sm%20text-text-secondary%22%7D" className="font-body text-sm text-text-secondary">
                {badge.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}